module.exports = __webpack_public_path__ + "img/applicable-2.08ae9905.png";